import pt from './pt';
import en from './en';
import de from './de';

const messages: Record<string, { translation: Record<string, string> }> = {
  pt: { translation: pt },
  en: { translation: en },
  de: { translation: de },
};

export default messages;